export class DayView {

    date: number;
    dogBookings: number[];
    availableDogPens: number;
    catBookings: number[];
    availableCatPens: number;
    order: number;
    calanderDate: string;
}
